/* eslint-disable import/prefer-default-export */
import { lazy } from 'react';

const StockDetail = lazy(() => import(/* webpackChunkName: "stock-detail" */ './StockDetail'));

export { StockDetail };
